const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {}

export const getChatEnv = () => {
  const endpoint = String(env.VITE_CHAT_ENDPOINT || '').trim()
  const tenantId = String(env.VITE_CHAT_TENANT_ID || '').trim()
  const storageKey = String(env.VITE_CHAT_STORAGE_KEY || 'timekeeping:chat').trim() || 'timekeeping:chat'
  const supportConsolePassword =
    String(env.VITE_SUPPORT_CONSOLE_PASSWORD || 'SparkleSupport!').trim() || 'SparkleSupport!'

  return {
    endpoint,
    tenantId,
    storageKey,
    supportConsolePassword,
    enabled: Boolean(endpoint && tenantId),
  }
}
